import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostFeldKategorieCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostFeldKategorieCommandService],
  exports: []
})
export class PostFeldKategorieCommandServiceModule { }
